module.exports = __webpack_public_path__ + "img/202505_05_sp.82489bab.jpg";